<template>
  <section
    id="checkoutReviewOrder"
    :class="[openClass, emptyCartClass, 'expandable_section', 'review-section']"
  >
    <h2
      class="expandable_header"
      @click="updateSection(sectionName)"
    >
      {{ number }}. {{ $t('checkout.payment.reviewOrder') }}
    </h2>

    <div class="expandable_content">
      <Cart
        @amount-update="updateStatePaymentFields"
      />

      <button
        v-if="cartHasItems"
        class="continue-button btn btn-primary"
        @click="updateSection(sectionNext)"
      >
        {{ $t('cookie.continue') }}
      </button>
    </div>
  </section>
</template>

<script>
import Cart from '../cart/cart'
import { mapMutations, mapState, mapActions } from 'vuex'

export default {
  components: {
    Cart
  },

  props: ['number'],

  data() {
    return {
      cartHasItems: true,
      sectionName: 'review',
      sectionNext: 'termsAndConditions',
    }
  },

  computed: {
    ...mapState('checkout', {
      section: state => state.section
    }),
    emptyCartClass() {
      return (this.cartHasItems) ? '' : 'empty'
    },

    selected() {
      return this.section == this.sectionName
    },

    openClass() {
      return (this.selected) ? 'open' : ''
    }
  },

  methods: {
    ...mapMutations('checkout', ['updatePaymentFields']),
    ...mapActions('checkout', ['updateSection']),
    updateStatePaymentFields(newFields) {
      if (newFields.itemCount > 0) {
        this.cartHasItems = true
      } else {
        this.cartHasItems = false

        // Make sure this section is selected so user is notified to keep shopping
        if (this.section != this.sectionName) { this.updateSection(this.sectionName) }
      }

      this.updatePaymentFields(newFields)
    }
  }
}
</script>
